document.addEventListener('DOMContentLoaded', function () {
  // Deep links: /pages/<handle>#shipping opens and scrolls to the box whose
  // section "Anchor ID" setting is "shipping".
  function getHashTarget(hash) {
    if (!hash || hash.length < 2) return null;
    var el;
    try {
      el = document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (e) {
      return null;
    }
    return el && el.classList.contains('warranty_accordian') ? el : null;
  }

  var sections = document.querySelectorAll('.warranty_accordian');

  // Only one box open at a time. Boxes above `keep` collapse instantly (no
  // transition) so `keep` doesn't keep sliding up while we scroll to it;
  // boxes below it don't affect its position, so they animate shut as usual.
  function closeOthers(keep) {
    sections.forEach(function (other) {
      if (other === keep || !other.classList.contains('is-open')) return;
      var isAbove = other.compareDocumentPosition(keep) & Node.DOCUMENT_POSITION_FOLLOWING;
      var textItem = other.querySelector('.image-with-text__text-item');
      if (isAbove && textItem) textItem.style.transition = 'none';
      other.classList.remove('is-open');
      if (isAbove && textItem) {
        void textItem.offsetHeight; // apply the collapse before restoring the transition
        textItem.style.transition = '';
      }
    });
  }

  function openHashTarget(target, smooth) {
    closeOthers(target);
    target.classList.add('is-open');
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  // Mark the linked box open (and the rest shut) before the boxes below collapse,
  // so it never flickers shut.
  var initialTarget = getHashTarget(window.location.hash);
  if (initialTarget) {
    closeOthers(initialTarget);
    initialTarget.classList.add('is-open');
  }

  sections.forEach(function (section) {
    var mediaItem = section.querySelector('.image-with-text__media');
    var textItem = section.querySelector('.image-with-text__text-item');
    if (!mediaItem || !textItem) return;

    if (!mediaItem.querySelector('.warranty-toggle-btn')) {
      var btn = document.createElement('button');
      btn.className = 'warranty-toggle-btn';
      btn.setAttribute('aria-label', 'Toggle section');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      mediaItem.appendChild(btn);
    }

    // Whole header (icon + text + chevron) is clickable now, not just the button
    mediaItem.style.cursor = 'pointer';
    mediaItem.addEventListener('click', function () {
      if (section.classList.contains('is-open')) {
        section.classList.remove('is-open');
        return;
      }
      // Keep the clicked header under the cursor when a box above it collapses.
      var topBefore = section.getBoundingClientRect().top;
      closeOthers(section);
      section.classList.add('is-open');
      var shift = section.getBoundingClientRect().top - topBefore;
      if (shift) window.scrollBy(0, shift);
    });

    // Wait 2 animation frames so the theme's own accordion script
    // has fully initialized/measured the rows BEFORE we collapse this box.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        textItem.classList.add('warranty-ready');
      });
    });
  });

  // Scroll only after the collapse above has run (these frames are queued after
  // it), otherwise the boxes collapsing would shift the target out of view.
  if (initialTarget) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        openHashTarget(initialTarget, false);
      });
    });
  }

  // Link to a different box while already on the page.
  window.addEventListener('hashchange', function () {
    var target = getHashTarget(window.location.hash);
    if (target) openHashTarget(target, true);
  });

  // Clicking a link whose hash is already in the URL fires no hashchange,
  // e.g. a box the user collapsed and then picked again from the menu.
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="#"]');
    if (!link || link.pathname !== window.location.pathname || link.hash !== window.location.hash) return;
    var target = getHashTarget(link.hash);
    if (target) openHashTarget(target, true);
  });
});
